import React from "react";
import "../styles/InfoPanels.css";

const SECTIONS = [
  {
    title: "Terms of Service",
    body: `By accessing or using Girinestham ("the Platform"), you agree to be bound by these Terms of Service. The Platform is provided to manage organizational workflows including attendance, property assets, certificates, and user management. Unauthorized use, reverse engineering, or redistribution of any part of the Platform is strictly prohibited. We reserve the right to suspend or terminate access for any user who violates these terms. These terms are governed by the laws of India.`,
  },
  {
    title: "Privacy Policy",
    body: `We collect only the information necessary to provide the services — including name, email, role, profile photos, attendance records, and device location (when geofencing is enabled). Your data is stored securely using industry-standard practices. We do not sell or share your personal data with third parties. Profile photos and documents may be stored locally, in Supabase, or in AWS S3 based on your administrator's configuration. You may request data deletion by contacting your organization's administrator.`,
  },
  {
    title: "Data Retention",
    body: `User data, attendance logs, and uploaded media are retained for as long as the user account is active. Soft-deleted records are preserved for audit purposes and can be permanently removed by an administrator. Session tokens expire based on security policies configured by the system administrator.`,
  },
  {
    title: "Cookie Policy",
    body: `The Platform uses cookies and local storage to maintain your authenticated session, store preferences, and ensure a smooth user experience. No tracking or advertising cookies are used. By using the Platform, you consent to the use of functional cookies.`,
  },
  {
    title: "Disclaimer",
    body: `The Platform is provided "as is" without warranties of any kind, express or implied. The developers and organization shall not be liable for any damages arising from the use or inability to use the Platform. Use of geolocation features is subject to device-level permissions granted by the user.`,
  },
];

export default function LegalPanel() {
  return (
    <div className="info-panel">
      <div className="info-panel__mesh" aria-hidden />

      <header className="info-panel__header">
        <p className="info-panel__eyebrow">Compliance</p>
        <h2 className="info-panel__title">Legal</h2>
        <p className="info-panel__sub">
          Review the terms, privacy policy, and legal information governing the use of this platform.
        </p>
      </header>

      {SECTIONS.map((section) => (
        <section key={section.title} className="info-panel__section">
          <h3 className="info-panel__section-title">{section.title}</h3>
          <p className="info-panel__body-text">{section.body}</p>
        </section>
      ))}
    </div>
  );
}
